module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("Many thanks to the following people, without whom "), _c('i', [_vm._v("Crystal Clear")]), _vm._v(" would still be a germ of an idea: former Barnes & Noble community relations whiz Judy Martin, who said, “So maybe your next heroine goes to an ashram?”; Ruth Harris, who came up with the book’s title; my agent, Ellen Levine, who was supportive beyond the call of duty; and my editor, Ann La Farge, who worked her usual magic on my words.")]), _vm._v(" "), _c('p', [_vm._v("Special thanks to my husband, Michael Forester, for allowing his aura to be cleansed, his energies to be palpated, and all the rest.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315da45a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 69
// module chunks = 0